// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const firebaseConfig = {
    apiKey: "AIzaSyDyJNE0KkyTE9cBubgTsSEvVLOapFOvXh4",
    authDomain: "ninja-travel.firebaseapp.com",
    databaseURL: "https://ninja-travel.firebaseio.com",
    projectId: "ninja-travel",
    storageBucket: "ninja-travel.appspot.com",
    messagingSenderId: "68162809604",
    appId: "1:68162809604:web:9cafdf8a76129042a32a51"
  };

export default firebaseConfig;